<template>
  <div class="o-item_body o-chnl_body c-chnls">
    <div class="c-chnl" v-for="(payType, index) in payTypes" :key="index">
      <div
        @click="
          selectPayType(
            payType,
            payType.child.length,
            payType.f_pay_type + index
          )
        "
      >
        <div class="c-chnl_box j-select-payType" :data-code="payType.name">
          <img
            alt=""
            v-bind:src="
              ICON_URI +
              payType.f_pay_type +
              '/mode2/' +
              payType.pay_type +
              '.png'
            "
            class="c-chnl_logo o-chnl-icon_mol-razer-pin j-select-payType"
            :data-code="payType.name"
          />
          <i
            class="icon-extra j-select-payType"
            v-if="payType.max_extra_ratio != 0"
            :data-code="payType.name"
          >
            {{ ~~(payType.max_extra_ratio * 100) }}%
          </i>
        </div>
        <a
          href="javascript:void(0);"
          class="c-chnl_name j-select-payType"
          :data-code="payType.name"
        >
          {{ payType.name }}
        </a>
      </div>
    </div>
    <!-- <div class="loading" v-show="isLoadingPriceList"></div> -->
    <transition name="fade">
      <div class="loading-mask" v-if="isLoadingPriceList">
        <div class="loading">
          <span class="loading-item"></span>
          <span class="loading-item"></span>
          <span class="loading-item"></span>
          <span class="loading-item"></span>
          <span class="loading-item"></span>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import SelectContainer from '../../mixins/SelectContainer';
import { RES_HOST } from '../../utiles';
import { mapGetters } from 'vuex';
export default {
  data() {
    const payTypeSeemIdentify = {};
    for (let i = 0, length = this.allPayTypes.length; i < length; i++) {
      payTypeSeemIdentify[this.allPayTypes[i]?.f_pay_type + i] = false;
    }
    return {
      ICON_URI: RES_HOST + 'commonImg/store/',
      payTypeSeemIdentify: payTypeSeemIdentify
    };
  },
  props: ['allPayTypes', 'curPayType'],
  computed: {
    payTypes() {
      let typs = [];
      for (let i = 0, len = this.allPayTypes.length; i < len; i++) {
        if (this.allPayTypes[i]?.price_list.length > 0) {
          typs.push(this.allPayTypes[i]);
        }
      }
      return typs;
    },
    ...mapGetters(['isLoadingPriceList'])
  },
  mixins: [SelectContainer],
  methods: {
    selectPayType(payType, hasChildPayTyp, targetParentKey) {
      !hasChildPayTyp
        ? this.$emit('selectPayWay', payType)
        : this.controlChildSeem(targetParentKey);
    },
    controlChildSeem(targetParentKey) {
      for (let i = 0, length = this.allPayTypes.length; i < length; i++) {
        this.allPayTypes[i]?.f_pay_type + i !== targetParentKey &&
          (this.payTypeSeemIdentify[
            this.allPayTypes[i]?.f_pay_type + i
          ] = false);
      }
      this.$set(
        this.payTypeSeemIdentify,
        targetParentKey,
        !this.payTypeSeemIdentify[targetParentKey]
      );
    },
    selectChildPayType(payType, childIndex) {
      // 选了哪个子渠道
      payType['selectChildIndex'] = childIndex;
      this.$emit('selectPayWay', payType);
    }
  }
};
</script>
<style lang="scss" scoped>
.loading-mask {
  position: absolute;
  background: rgba(255, 255, 255, 0.8);
}
</style>
